export enum AutoActivationMode {
  'AllUsers' = 'AllUsers',
  'NewUsers' = 'NewUsers',
  'Disabled' = 'Disabled'
}
